import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminFormDefinitionVersionPreview } from "@/types/form-fields"

export type AdminFormDefinitionVersionPreviewState = {
  data: AdminFormDefinitionVersionPreview | null
  error: string | null
}

export const adminFormDefinitionVersionPreviewInitialState: AdminFormDefinitionVersionPreviewState = {
  data: null,
  error: null,
}

const slice = createSlice({
  name: "adminFormDefinitionVersionPreview",
  initialState: adminFormDefinitionVersionPreviewInitialState,
  reducers: {
    setAdminFormDefinitionVersionPreviewAction(
      state,
      { payload }: PayloadAction<AdminFormDefinitionVersionPreview | null>,
    ) {
      state.data = payload
      state.error = null
    },
    setAdminFormDefinitionVersionPreviewErrorAction(
      state,
      { payload }: PayloadAction<string | null>,
    ) {
      state.error = payload
    },
  },
})

export const {
  setAdminFormDefinitionVersionPreviewAction,
  setAdminFormDefinitionVersionPreviewErrorAction,
} = slice.actions
export default slice.reducer
